import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

export const ThreadResolveInputsSchema = z.object({
  // Required: Communication channel
  'communication-channel-id': z
    .string()
    .describe('Communication channel to use for the thread'),

  // Entry point options (at least one required, checked in priority order)

  // Option 1: Participant ID (fastest - skip contact lookup)
  'participant-id': z
    .string()
    .optional()
    .describe('Existing participant ID - skips contact/subscription lookup'),

  // Option 2: Contact ID (skip instance lookup)
  'contact-id': z
    .string()
    .optional()
    .describe('Existing contact ID - uses their subscription on the channel'),

  // Option 3: Instance resolution (uses ChannelModelLink)
  'instance-id': z
    .string()
    .optional()
    .describe('CRM Instance ID - identifier resolved via ChannelModelLink'),

  // Option 4: Explicit identifier (most flexible, creates everything)
  'identifier-value': z
    .string()
    .optional()
    .describe('Explicit identifier value (phone, email, etc.)'),

  // Optional: Contact name (falls back to instance label or identifier-value)
  name: z
    .string()
    .optional()
    .describe(
      'Contact name (optional - falls back to instance label or identifier-value)',
    ),

  // Optional: Associate with instance (works with any entry point)
  'associate-instance-id': z
    .string()
    .optional()
    .describe(
      'Instance ID to associate with the contact (optional, for linking)',
    ),

  // Optional thread configuration
  title: z
    .string()
    .optional()
    .describe('Thread title (defaults to contact name)'),
  'source-thread-id': z
    .string()
    .optional()
    .describe('Source thread ID for linking'),
  'source-message-id': z
    .string()
    .optional()
    .describe('Source message ID for linking'),
})

const ThreadResolveOptionsSchema = z.object({})

export const ThreadResolveCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/threads'),
    cmd: z.literal('thread.resolve'),
    options: ThreadResolveOptionsSchema.optional(),
  }),
  inputs: ThreadResolveInputsSchema,
})

export type ThreadResolveCommand = z.infer<typeof ThreadResolveCommandSchema>
